/* Goodnap theme JS — variant picker, gallery, accordions, sticky ATC.
   Sections register their behaviour by data-attribute. */

(function () {
  'use strict';

  // ─── Mobile media query, used by gallery ───
  const mqMobile = window.matchMedia('(max-width: 880px)');

  // ─── Color swatch + size pill: simple class toggle + label update ───
  document.querySelectorAll('[data-color-row]').forEach((row) => {
    row.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-color-chip]');
      if (!chip) return;
      row.querySelectorAll('[data-color-chip]').forEach((c) => c.classList.remove('is-active'));
      chip.classList.add('is-active');
      const label = document.querySelector('[data-color-name]');
      if (label && chip.dataset.name) label.textContent = chip.dataset.name;
      updateVariant();
    });
  });

  document.querySelectorAll('[data-size-row]').forEach((row) => {
    row.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-size-pill]');
      if (!pill || pill.disabled) return;
      row.querySelectorAll('[data-size-pill]').forEach((p) => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      const label = document.querySelector('[data-size-name]');
      if (label && pill.dataset.name) label.textContent = pill.dataset.name;
      updateVariant();
    });
  });

  // ─── Variant lookup against a JSON blob written by the hero section ───
  function updateVariant() {
    const dataEl = document.getElementById('ProductVariantData');
    if (!dataEl) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const colorEl = document.querySelector('[data-color-chip].is-active');
    const sizeEl = document.querySelector('[data-size-pill].is-active');
    if (!colorEl || !sizeEl) return;

    const color = colorEl.dataset.value;
    const size = sizeEl.dataset.value;

    const match = variants.find((v) =>
      v.options.includes(color) && v.options.includes(size)
    );
    if (!match) return;

    // Update price + ATC
    document.querySelectorAll('[data-variant-price]').forEach((el) => {
      el.textContent = formatMoney(match.price);
    });
    document.querySelectorAll('[data-variant-id]').forEach((el) => {
      el.value = match.id;
      el.setAttribute('data-variant-id', match.id);
    });

    // Update URL
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url);
    }
  }

  function formatMoney(cents) {
    const v = (cents / 100).toFixed(2);
    return `$${v}`;
  }

  // ─── Thumbnail rail (desktop) ───
  document.querySelectorAll('[data-thumb-rail]').forEach((rail) => {
    rail.addEventListener('click', (e) => {
      const t = e.target.closest('[data-thumb]');
      if (!t) return;
      rail.querySelectorAll('[data-thumb]').forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
      const idx = parseInt(t.dataset.index || '0', 10);
      const main = document.querySelector('[data-gallery-main]');
      if (main) {
        main.querySelectorAll('[data-gallery-slide]').forEach((s) => s.classList.remove('is-active'));
        const target = main.querySelector(`[data-gallery-slide="${idx}"]`);
        if (target) target.classList.add('is-active');
      }
    });
  });

  // ─── Mobile gallery: swipe-snap with dots + counter ───
  document.querySelectorAll('[data-gallery-track]').forEach((track) => {
    const dots = track.parentElement.querySelectorAll('[data-gallery-dot]');
    const counter = track.parentElement.querySelector('[data-gallery-counter]');
    const update = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
      if (counter) counter.textContent = `${i + 1} / ${dots.length || 1}`;
    };
    track.addEventListener('scroll', update, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }));
    update();
  });

  // ─── Sticky ATC: appears when hero scrolls offscreen ───
  const atc = document.querySelector('[data-sticky-atc]');
  const heroEnd = document.querySelector('[data-hero-end]');
  if (atc && heroEnd) {
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        ([entry]) => atc.classList.toggle('is-hidden', entry.isIntersecting),
        { rootMargin: '0px 0px -80px 0px' }
      );
      obs.observe(heroEnd);
    } else {
      const onScroll = () => {
        const r = heroEnd.getBoundingClientRect();
        atc.classList.toggle('is-hidden', r.bottom > 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  // ─── Add To Bag (AJAX) ───
  document.querySelectorAll('[data-atc]').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const idEl = document.querySelector('[data-variant-id]');
      const id = idEl && idEl.value;
      if (!id) return;
      const original = btn.innerHTML;
      btn.disabled = true;
      btn.dataset.busy = 'true';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        if (!res.ok) throw new Error('atc failed');
        btn.innerHTML = '<span>Added ✓</span>';
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { id } }));
        // Open cart drawer if the theme has one
        const drawer = document.querySelector('[data-cart-drawer]');
        if (drawer) drawer.classList.add('is-open');
        setTimeout(() => { btn.innerHTML = original; btn.disabled = false; }, 1600);
      } catch (err) {
        btn.innerHTML = original;
        btn.disabled = false;
        console.error(err);
      }
    });
  });
})();
